import {ApiError} from "../model/ApiError.model";
import {ApiBase} from "./ApiBase";
import {AxiosResponse} from "axios";

export interface IApiResult<T> {
    data?: T;
    error?: ApiError;
}

export class AxiosWealthManagementApiImpl {
    public static sendFeedback(text: string):  Promise<IApiResult<string>> {
        return ApiBase.processPostWithResponseBody(
            `/feedback-items`,
            { feedbackText: text },
            (response: AxiosResponse) => {
                return response.data;
            });
    }
}
